import { render, staticRenderFns } from "./update-resource.vue?vue&type=template&id=4a8955d8&scoped=true&"
import script from "./update-resource.vue?vue&type=script&lang=js&"
export * from "./update-resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8955d8",
  null
  
)

export default component.exports